import Report from "../../../models/report/report";
import ReportCategory from "../../../models/report/report-category";
import ReportChecklistItem from "../../../models/report/report-checklist-item";
import ReportLocation from "../../../models/report/report-location";
import ReportThumbnailsChecklistItem from "../../../models/report/report-thumbnails-checklist-item";

export const generateReportsForVSAFromVehicleInspectionDetailsResponse = (
  response,
  vsaActions
) => {
  const result = new Report();
  const resultThumbnails = new Report();

  response.inspectionTemplate.locations.forEach((location, locationIndex) => {
    //Add locations to both reports

    result.locations.push(
      new ReportLocation(
        location.locationId,
        location.locationTitle,
        locationIndex
      )
    );

    resultThumbnails.locations.push(
      new ReportLocation(
        location.locationId,
        location.locationTitle,
        locationIndex
      )
    );

    location.categories.forEach((category, categoryIndex) => {
      //Add categories to both reports

      result.locations[locationIndex].categories.push(
        new ReportCategory(
          category.categoryId,
          category.categoryTitle,
          categoryIndex
        )
      );

      resultThumbnails.locations[locationIndex].categories.push(
        new ReportCategory(
          category.categoryId,
          category.categoryTitle,
          categoryIndex
        )
      );

      category.checklist.forEach((checklist) => {
        //Add checklistItems to each category in reports

        result.locations[locationIndex].categories[
          categoryIndex
        ].checklistResponses.push(
          new ReportChecklistItem(
            checklist.checklistItemId,
            checklist.inputType
          )
        );

        resultThumbnails.locations[locationIndex].categories[
          categoryIndex
        ].checklistResponses.push(
          new ReportThumbnailsChecklistItem(checklist.checklistItemId)
        );
      });
    });
  });

  //Update the results to VSA state
  vsaActions.updateReport(result);
  vsaActions.updateReportThumbnails(resultThumbnails);
};
